import { epApiAxios } from "config/axios/ep";
import { EP_API_END_POINT } from "config/index";
import { LeaderBoard } from "src/model/LeaderBoard";
import Axios from "axios";

export const LeaderBoardService = {
  async getLeaderBoard(data = {}) {
    //region - G | C | S | I  (Global, Country, State, City)

    //period - M | W | D | E (Monthly, Weekly, Daily, Ever)

    //type - xp | score
    const {
      page = 1,
      count = 10,
      type = "xp",
      region = "G",
      period = "W",
      gameId = undefined,
    } = data;

    const res = await epApiAxios.get(
      `/leaderboard/${type}/region/${region}/time/${period}/list`,
      {
        params: {
          game_id: gameId,
          page,
          count,
        },
      }
    );
    return LeaderBoard.fromAll(res?.data);
  },
  async getTopLeaderBoard(data = {}) {
    const {
      type = "xp",
      region = "G",
      period = "W",
      gameId = undefined,
      limit = 3,
      liveness = "delayed",
    } = data;

    const res = await epApiAxios.get(
      `/leaderboard/${type}/region/${region}/time/${period}/rank/top-n/get`,
      {
        params: {
          game_id: gameId,
          limit,
          liveness,
        },
      }
    );
    return LeaderBoard.fromAll(res.data);
  },
  async getUserRank(data = {}) {
    //region - G | C | S | I  (Global, Country, State, City)

    //period - M | W | D | E (Monthly, Weekly, Daily, Ever)

    //type - xp | score

    //liveness - delayed | realtime
    const {
      type = "xp",
      region = "G",
      period = "W",
      gameId = undefined,
      liveness = "delayed",
    } = data;

    const res = await epApiAxios.get(
      `/leaderboard/${type}/region/${region}/time/${period}/rank/get`,
      {
        params: {
          game_id: gameId,
          liveness,
        },
      }
    );
    return LeaderBoard.from(res.data);
  },
  async getUserHighScore(data = {}) {
    const { type = "score", gameId = undefined } = data;

    const res = await epApiAxios.get(`/leaderboard/${type}/high-score/get`, {
      params: {
        game_id: gameId,
      },
    });
    return LeaderBoard.from(res.data);
  },
  async getUserCursor(data = {}) {
    const {
      type = "xp",
      region = "G",
      period = "W",
      gameId = undefined,
    } = data;

    const res = await epApiAxios.get(
      `/leaderboard/${type}/region/${region}/time/${period}/cursor/get`,
      {
        params: {
          game_id: gameId,
        },
      }
    );
    return res.data;
  },
  async getUserCursorList(data = {}) {
    const {
      beforeCount = 1,
      afterCount = 1,
      beforeCursor = 1,
      afterCursor = 1,

      type = "xp",
      region = "G",
      period = "W",
      gameId = undefined,
    } = data;

    const res = await epApiAxios.get(
      `/leaderboard/${type}/region/${region}/time/${period}/rank/get`,
      {
        params: {
          game_id: gameId,
          before_count: beforeCount,
          after_count: afterCount,
          before_cursor: beforeCursor,
          after_cursor: afterCursor,
        },
      }
    );
    return res.data;
  },
};
